export type StationWorkoutCount = {
  workoutId: number | null
  workoutName: string | null
  count: number
}

export type StationClassCount = {
  interactiveClassId: number | null
  className: string | null
  count: number
}

export type StationClassInfo = {
  id: number
  name: string | null
  previewImage: string | null
}

export type StationClassDay = {
  date: string
  count: number
  classes: StationClassCount[]
}

export default class StationWorkoutsDay {

  date: string
  total: number = 0
  workouts: StationWorkoutCount[] = []
  classCount: number = 0
  classes: StationClassCount[] = []

  constructor (attributes: any = null) {
    if (attributes) Object.assign(this, attributes)
  }
}
